// extracted by mini-css-extract-plugin
export var logo = "_9i-2";
export var logoWrapper = "_9i-1";
export var strip = "_9i-0";